import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/compatibility-visual")({
  head: () =>
    pageHead("Compatibility Reading", {
      canonicalPath: "/compatibility-visual",
      robots: "noindex, nofollow",
    }),
});
